import React, { useState } from "react";

import DeliveryHead from "../DeliveryHead";
import { Grid, Container, Button } from "@mui/material";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import AuthInput from "../../../shared/authinput";
import MainButton from "../../../shared/Button";

import "react-datepicker/dist/react-datepicker.css";
import RouteSecStop from "./RouteSecStop";
import PreviewOrder from "./PreviewOrder";
import fileupload from "../../../../assets/images/fileupload.svg";
import CloseIcon from "@mui/icons-material/Close";
import { ImageContainer } from "../../../shared/commonstyle/ImagePreview";

import {
  RouteStepMain,
  InputFlexWrap,
  CargoDescription,
  ErrorSpan,
  FileUploadWrap,
  DateTimeWrap,
  CustomDateTime,
} from "../styles/RouteOrderDetailsStyle";
import { RouteOrderDetailsvalidation } from "../../../../helpers/validations/delivery/RouteSteps";

const RouteOrderDetails = ({ NavigateCallback }) => {
  const [NextStep, SetNextStep] = useState(false);
  const [ShowConfirmPage, SetShowConfirmPage] = useState(false);
  const [ShowTheNextPage, SetShowTheNextPage] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  let CirPercentage = 50;

  const ShowPreviusPage = () => {
    NavigateCallback(false);
  };

  const handleSubmit = (values) => {
    // console.log("values", values);
    SetNextStep(true);
    setSelectedImages([]);
  };

  const handleImageChange = (event, arrayHelpers) => {
    const files = event.target.files;
    const fileArray = Array.from(files);
    setSelectedImages(fileArray);
    arrayHelpers.push(fileArray);
  };

  const handleRemoveImage = (index, setFieldValue) => {
    const updatedImages = [...selectedImages];
    updatedImages.splice(index, 1);
    setSelectedImages(updatedImages);
    setFieldValue("CargoImages", updatedImages);
  };

  return (
    <>
      {!NextStep && !ShowTheNextPage ? (
        <>
          <DeliveryHead
            Value={CirPercentage}
            BackLink="/route-stop-one"
            CenterText="Order Details "
            StepText="2 of 4"
            haveCallBack={true}
            CallBackFun={ShowPreviusPage}
          />
          <RouteStepMain className="customer__dateinputs">
            <Container maxWidth="lg">
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12} md={10} lg={8}>
                  <Formik
                    initialValues={{
                      CargoName: "",
                      WidthLbs: "",
                      WidthIn: "",
                      HeightIn: "",
                      Length: "",
                      CargoImages: [],
                      DateTime: "",
                      CargoDescription: "",
                    }}
                    validationSchema={RouteOrderDetailsvalidation}
                    onSubmit={handleSubmit}
                  >
                    {(formik) => (
                      <Form autocomplete="off">
                        <InputFlexWrap>
                          <InputFlexWrap className="CargoNameFlexWrap">
                            <Field
                              type="text"
                              name="CargoName"
                              label="Cargo"
                              component={AuthInput}
                              placeholder="Enter cargo name"
                            />
                            <Field
                              type="number"
                              name="WidthLbs"
                              label="Weight"
                              component={AuthInput}
                              placeholder="Weight"
                              inputMoreText="Lbs"
                              haveMoreText={true}
                            />
                          </InputFlexWrap>

                          <InputFlexWrap className="DimensionsFlexWrap">
                            <Field
                              type="number"
                              name="Length"
                              label="Dimensions"
                              component={AuthInput}
                              placeholder="Length"
                              inputMoreText="In"
                              haveMoreText={true}
                            />
                            <Field
                              type="number"
                              name="WidthIn"
                              label=""
                              component={AuthInput}
                              placeholder="Width"
                              inputMoreText="In"
                              haveMoreText={true}
                              nolabel={true}
                            />
                            <Field
                              type="number"
                              name="HeightIn"
                              label=""
                              component={AuthInput}
                              placeholder="Height"
                              inputMoreText="In"
                              haveMoreText={true}
                              nolabel={true}
                            />
                          </InputFlexWrap>
                        </InputFlexWrap>

                        {/* image and date time  */}

                        <InputFlexWrap>
                          <FileUploadWrap>
                            <label>Cargo Image</label>
                            <Button
                              variant="contained"
                              component="label"
                              className="ButtonContainer"
                            >
                              <span className="ButtonLabel">
                                Add your cargo image
                                <img src={fileupload} alt="fileupload" />
                              </span>

                              <FieldArray name="CargoImages">
                                {(arrayHelpers) => (
                                  <input
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    hidden
                                    onChange={(event) =>
                                      handleImageChange(event, arrayHelpers)
                                    }
                                  />
                                )}
                              </FieldArray>
                            </Button>

                            {formik.touched.CargoImages &&
                              formik.errors.CargoImages && (
                                <ErrorSpan className="errorSpan">
                                  {formik.errors.CargoImages}
                                </ErrorSpan>
                              )}
                          </FileUploadWrap>

                          <DateTimeWrap>
                            <label>Date & Time</label>
                            <CustomDateTime
                              selected={formik.values.DateTime}
                              onChange={(date) =>
                                formik.setFieldValue("DateTime", date)
                              }
                              showTimeSelect
                              timeFormat="HH:mm"
                              timeIntervals={15}
                              dateFormat="MM/dd/yyyy h:mm aa"
                              placeholderText="Select pickup date & time"
                              className="form-control"
                              popperProps={{
                                positionFixed: true, // use this to make the popper position: fixed
                              }}
                            />
                            {formik.touched.DateTime &&
                              formik.errors.DateTime && (
                                <ErrorSpan className="errorSpan">
                                  {formik.errors.DateTime}
                                </ErrorSpan>
                              )}
                          </DateTimeWrap>
                        </InputFlexWrap>
                        {/* End image and date time  */}

                        {/* Cargo Description */}

                        <CargoDescription
                          className={
                            formik.errors.CargoDescription ? "haveBorder" : ""
                          }
                        >
                          <label>Cargo Description</label>
                          <Field
                            as="textarea"
                            name="CargoDescription"
                            placeholder="Enter cargo description"
                          />

                          {formik.touched.CargoDescription &&
                            formik.errors.CargoDescription && (
                              <ErrorSpan>
                                {formik.errors.CargoDescription}
                              </ErrorSpan>
                            )}
                        </CargoDescription>

                        {/*End Cargo Description */}
                        {/* show the images */}
                        {selectedImages && (
                          <ImageContainer className="ImageContainer">
                            {selectedImages.map((file, index) => (
                              <div
                                key={index}
                                className="ImageItem"
                                style={{
                                  backgroundImage: `url(${URL.createObjectURL(
                                    file
                                  )})`,
                                }}
                              >
                                <CloseIcon
                                  className="RemoveIcon"
                                  onClick={() =>
                                    handleRemoveImage(
                                      index,
                                      formik.setFieldValue
                                    )
                                  }
                                />
                              </div>
                            ))}
                          </ImageContainer>
                        )}
                        {/* End show the images */}

                        <MainButton
                          type="submit"
                          label="Add Order Details"
                          MT="110"
                        />
                      </Form>
                    )}
                  </Formik>
                </Grid>
              </Grid>
            </Container>
          </RouteStepMain>
        </>
      ) : (
        <RouteSecStop NavigateCallback={SetNextStep} />
      )}
    </>
  );
};

export default RouteOrderDetails;
